import styled from "styled-components";

export const SummaryValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(0)};
`;
